import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

@Injectable()
export class ValidateErrorService {

  constructor(
  ) { }

  private getError(err) {
    const keys = Object.keys(err);
    return keys.map(key => {
      const {message} = err[key][0];
      return {
        message,
        key
      };
    })[0];
  }

  /**
   * Привязывает ошибку к полю
   * @param error {message: String} Ошибка
   * @param control AbstractControl Контрол формы, к которому привязана ошибка
   */
  public setError(error, control) {
    control.setErrors({
      'remote': error.message
    });
    control.markAsDirty();
  }


  /**
   * Матчит ошибки бекенда на форму. Если приходит ошибка 403 без контрола, показввает алерт
   * @param err {Objcet} Объект ошибки, который вернул сервер
   * @param form {FormControl} Объект формы, которую валидируем
   */
  public check(err, form: FormGroup) {
    const error = this.getError(err);
    const control = form.controls[error.key];
    if (control) {
      this.setError(error, control);
    }
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/validate-error.service.ts